// Import the type but not the module, to avoid bundling Sentry.
import type * as SentryType from "@sentry/browser";
const Sentry = (window as any).Sentry as typeof SentryType;

export class IssueLogger {
    public static log(message: string, tag?: string, context?: any): void {
        try {
            if (!Sentry) {
                return;
            }

            Sentry.withScope(function (scope) {
                if (context) {
                    scope.setExtra("additional", context);
                }

                if (tag) {
                    scope.setTag("operation", tag);
                }

                Sentry.captureMessage(message);
            });
        } catch (e) {
            // Sentry not loaded, probably due to ad blockers.
        }
    }
}
